export default __webpack_public_path__ + "static/media/Lost_and_Found_LE.30668db3.jpg";